export class StpViewerConfig {
    public is3dMode: boolean;
    constructor() {
        this.is3dMode = false;
    }
}